module.exports = __webpack_public_path__ + "assets/img/limit_192.011eb7dd.png";